function ReactSearchDrawer(props) {
  const [DrawerHeigt, setDrawerHeight] = React.useState("0");
  const [drawerBackVis, setDrawerBackVis] = React.useState("hidden");
  function drawerSwitch(e) {
    e.preventDefault();
    drawerBackVis == "hidden" ? setDrawerBackVis("visible") : setDrawerBackVis("hidden");
    document.querySelector("body").classList.contains("blockScroll") ? document.querySelector("body").classList.remove("blockScroll") : document.querySelector("body").classList.add("blockScroll");
    DrawerHeigt == "fit-content" ? setDrawerHeight("1px") : setDrawerHeight("fit-content");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "react-drawer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "drawerBack",
    onClick: e => drawerSwitch(e),
    style: {
      visibility: drawerBackVis
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "drawerArea drawerAreaTop",
    style: {
      height: DrawerHeigt,
      background: "white",
      visibility: drawerBackVis
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mobile-menu-drawer",
    style: window.innerWidth < 450 ? {
      minWidth: window.innerWidth + "px"
    } : {
      minWidth: "450px"
    }
  }, DrawerHeigt != "0" && /*#__PURE__*/React.createElement(ReactSearch, {
    close: drawerSwitch
  }))), /*#__PURE__*/React.createElement("button", {
    className: "site-nav__link site-nav__link--icon",
    "aria-label": "Search",
    onClick: e => drawerSwitch(e)
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "searchIcon"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z",
    style: {
      fill: 'none',
      stroke: '#000'
    }
  }))));
}
const domContainerFordrawer2 = document.querySelector('#reactSearchDrawer');
const rootFordrawer2 = ReactDOM.createRoot(domContainerFordrawer2);
rootFordrawer2.render( /*#__PURE__*/React.createElement(ReactSearchDrawer, null));
